import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';



@Component({
  selector: 'app-frequenza',
  imports: [MatFormFieldModule, MatInputModule, MatTimepickerModule, MatIcon, MatDatepickerModule, ReactiveFormsModule, FormsModule, MatSelectModule, MatFormFieldModule, MatCardModule, MatButtonModule, MatCheckboxModule, CommonModule, MatProgressBarModule, MatListModule],
  templateUrl: './frequenza.component.html',
  styleUrl: './frequenza.component.css',
    
  providers: [provideNativeDateAdapter(),{provide: MAT_DATE_LOCALE, useValue: 'it-IT'}]
    
  
})
export class FrequenzaComponent {


  @Output() valueChange = new EventEmitter<string>();

  dataInizio: any;
  dataFine: any;
  stringFrequenza: any = '';
  riepilogoFrequenza: any = '';
  controllaDisp: boolean = false;

  formControl: FormControl<Date | null>;

  formFrequenza = new FormGroup({
    girono: new FormControl<any>(null)
  });

  constructor(private fb: FormBuilder) {
    const initialValue = new Date();
    initialValue.setHours(12, 30, 0);
    this.formControl = new FormControl(initialValue);


    this.form = this.fb.group({
      groups: this.fb.array([]),
    });

    this.addGroup();
  }

  giorni = new FormControl('');
  giorniLst: string[] = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica']




  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    console.log(event.value);
    this.dataInizio = event.value;
    this.creaStringFrequenza();
  }

  addEvent2(type: string, event2: MatDatepickerInputEvent<Date>) {
    console.log(event2.value);
    this.dataFine = event2.value;
    this.creaStringFrequenza();
  }


  creaStringFrequenza() {
    this.stringFrequenza = 'Dal: ' + this.dataInizio + ' al: ' + this.dataFine;

  }

  form: FormGroup;



  get groups(): FormArray {
    return this.form.get('groups') as FormArray;
  }

  addGroup(): void {
    const group = this.fb.group({
      datainizio: ['', Validators.required],
      datafine: ['', Validators.required],
      oraInizio: ['', Validators.required],
      oraFine: ['', Validators.required],
      giorni: ['', Validators.required],
      festivi: [''],
    });


    group.valueChanges.subscribe((value) => {
      console.log('Group value changed:', value);
      this.updateValueStrings();
    });

    this.groups.push(group);
  }

  removeGroup(index: number): void {
    this.groups.removeAt(index);
    this.updateValueStrings();
  }

  joinWithAnd(arr: any) {
    if (arr.length === 0) return '';

    if (arr.length === 1) return 'il giorno ' + arr[0];

    const lastElement = arr.pop(); // Remove the last element
    return 'i giorni ' + arr.join(', ') + ' e ' + lastElement;
  }


  valueStrings: string[] = [];

  updateValueStrings(): void {
    this.valueStrings = this.groups.controls.map(group => {

      if (!group.invalid) {


        this.controllaDisp = true;


        const value = group.value;

        const formatDate = (date: string) => {
          if (!date) return '';
          const d = new Date(date);
          return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
        };

        const formatTime = (time: string) => {
          if (!time) return '';
          const t = new Date(time);
          return `${t.getHours().toString().padStart(2, '0')}:${t.getMinutes().toString().padStart(2, '0')}`;
        };

        const datainizio = formatDate(value.datainizio);
        const datafine = formatDate(value.datafine);
        const oraInizio = formatTime(value.oraInizio);
        const oraFine = formatTime(value.oraFine);
        const giorni = this.joinWithAnd(value.giorni);
        const festivi = value.festivi ? 'esclusi i festivi' : '';

        return `Dal ${datainizio} al ${datafine}, ${giorni}, dalle ${oraInizio} alle ${oraFine} ${festivi}`;

      }
      return '';
    });


    this.riepilogoFrequenza = this.valueStrings.join(' - ');
  }




  onSubmit(): void {
    const valueToSend = this.riepilogoFrequenza;
    this.valueChange.emit(valueToSend);
  }



}
